window.app_models.policyholder = {
    "id":null,
    "name":null,
    "adults":null,
    "notes":null,
    "smoking":null,
    "pets":null,
    "pet_breed":null,
    "placement_id":null,
    "spanish": false,
    "children":[
      window.app_models.child  
    ],
    "primary_contact":window.app_models.contact,
    "secondary_contact":window.app_models.contact
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/policyholder.js